// Dummy/placeholder data for the Dashboard page.
// Hardcoded for now — no Redux, no API calls.
// Once backend integration begins, these constants are the values to replace
// with data fetched from the API (see each component's props for the expected shape).

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { FaWhatsapp, FaFacebookMessenger, FaInstagram, FaGlobe } from "react-icons/fa";

// STAGES placeholder removed — LifecyclePipeline now fetches real, workspace-scoped
// stage + count data itself (see LifecyclePipeline.jsx / lifecycleStageSlice.js).
export const STAGES_PER_PAGE = 4;

// Keys match ContactsModel's `platform` enum (whatsapp | instagram | facebook | website) — see
// ContactRow, which indexes this map with the real contact's `platform` field.
export const CHANNEL_ICON = {
  whatsapp: { Icon: FaWhatsapp, bg: "#2FAE68" },
  facebook: { Icon: FaFacebookMessenger, bg: "linear-gradient(135deg, #1E7FE0 0%, #3DB8BB 100%)" },
  instagram: { Icon: FaInstagram, bg: "radial-gradient(circle at 30% 107%, #f5cf5a 0%, #f5cf5a 5%, #e85f45 45%, #b5348a 60%, #3d63d8 90%)" },
  // Web Chat: same globe + #7C5CFF as Inbox's PlatformIcon.jsx.
  website: { Icon: FaGlobe, bg: "#7C5CFF" },
};

// Unassigned uses amber (not red) — matches the Unattended card's existing "needs
// attention" accent elsewhere on this page, less alarming than red for a filter tab.
export const STATUS_COLOR = { Assigned: "#22c55e", Unassigned: "#f59e0b", Closed: "#6b7280" };

// Status options are a fixed, known-ahead-of-time set (unlike Teams, which is open-ended
// and now fetched from the API — see TeamMembersPanel.jsx), so icons make sense here to
// communicate meaning at a glance.
export const STATUS_ICONS = {
  Assigned: { Icon: CheckCircleOutlineIcon, color: "#22c55e" },
  Unassigned: { Icon: PersonOffOutlinedIcon, color: "#ef4444" },
  Online: { Icon: FiberManualRecordIcon, color: "#22c55e" },
  Away: { Icon: FiberManualRecordIcon, color: "#f59e0b" },
};

